import { render, staticRenderFns } from "./PersonalGoalCard.vue?vue&type=template&id=7ae991c4"
import script from "./PersonalGoalCard.vue?vue&type=script&lang=js"
export * from "./PersonalGoalCard.vue?vue&type=script&lang=js"
import style0 from "./PersonalGoalCard.vue?vue&type=style&index=0&id=7ae991c4&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports